import React, { useState, useRef, useCallback } from 'react';
import CS from '../../commons/services/Common'
import * as _ from 'lodash-joins'
import ReactFlow, {
    ReactFlowProvider, addEdge, applyNodeChanges, applyEdgeChanges, useNodesState, useEdgesState, useStore, Controls
  } from 'react-flow-renderer';

const inverterStyle = {
    background: '#F6F6F6',
    color: '#FFBB00',
    border: '1px solid #222138',
    width: 40,
    height: 40
}
const moduleStyle = {
    background: '#F6F6F6',
    color: 'red',
    fontSize: 1,
    border: '1px solid #222138',
    width: 20,
    height: 40,
    //transform: "translate(0px, -150px) rotate(30deg)"
}
const buttonStyle = { position: 'absolute', right: 10, top: 30, zIndex: 4 };

const initialNodes = [
    { id: '1', type: 'input', sourcePosition: 'right', className: 'dark-node', data: { label: '인버터 1' }, style: inverterStyle, position: { x: -100, y: -100 } },
    { id: '1-1-1', stringId: "1-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.1.1' }, position: { x: 0, y: -150 } },
    { id: '1-1-2', stringId: "1-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.1.2' }, },
    { id: '1-1-3', stringId: "1-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.1.3' }, },
    { id: '1-1-4', stringId: "1-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.1.4' }, },
    { id: '1-1-5', stringId: "1-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.1.5' }, },
    { id: '1-1-6', stringId: "1-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.1.6' }, },
    { id: '1-1-7', stringId: "1-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.1.7' }, },
    { id: '1-2-1', stringId: "1-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.2.1' }, position: { x: 0, y: -90 } },
    { id: '1-2-2', stringId: "1-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.2.2' } },
    { id: '1-2-3', stringId: "1-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.2.3' } },
    { id: '1-2-4', stringId: "1-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.2.4' } },
    { id: '1-2-5', stringId: "1-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.2.5' } },
    { id: '1-2-6', stringId: "1-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.2.6' } },
    { id: '1-2-7', stringId: "1-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 1.2.7' } },

    { id: '2', type: 'input', sourcePosition: 'right', className: 'dark-node', data: { label: '인버터 2' }, style: inverterStyle, position: { x: -100, y: -300 } },
    { id: '2-1-1', stringId: "2-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.1.1' }, position: { x: 0, y: -350 } },
    { id: '2-1-2', stringId: "2-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.1.2' }, },
    { id: '2-1-3', stringId: "2-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.1.3' }, },
    { id: '2-1-4', stringId: "2-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.1.4' }, },
    { id: '2-1-5', stringId: "2-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.1.5' }, },
    { id: '2-1-6', stringId: "2-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.1.6' }, },
    { id: '2-1-7', stringId: "2-1", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.1.7' }, },
    { id: '2-2-1', stringId: "2-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.2.1' }, position: { x: 0, y: -290 } },
    { id: '2-2-2', stringId: "2-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.2.2' } },
    { id: '2-2-3', stringId: "2-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.2.3' } },
    { id: '2-2-4', stringId: "2-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.2.4' } },
    { id: '2-2-5', stringId: "2-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.2.5' } },
    { id: '2-2-6', stringId: "2-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.2.6' } },
    { id: '2-2-7', stringId: "2-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.2.7' } },
    { id: '2-2-8', stringId: "2-2", sourcePosition: 'right', targetPosition: 'left', data: { label: '모듈 2.2.8' } },
];

const invNodes = [];
const modNodes = [];
const angle = 30;
const width = 20;
const height = 40;
initialNodes.some((v, i) => {
    if (v.type === 'input') {
        invNodes.push(v);
    } else {
        modNodes.push(v);
    }
});

const groups = [];
invNodes.some((v, i) => {
    const inverterId = v.id;
    const group = _.chain(modNodes)
        .groupBy(v => `${v.stringId}`)
        .map((modules, stringId) => ({ stringId, modules }))
        .value();
    //console.log(group)
    groups.push({
        inverterId: v.id,
        strings: group //group.filter(v => v.stringId.indexOf(v.id + "-") > -1)
    })
});
//console.log(groups);

const initialEdges = [];
groups.some((v, i) => {
    v.strings.some( (v2, i2) => {
        const modules = v2.modules;
        let x = modules[0].position.x;
        let y = modules[0].position.y;
        initialEdges.push({
            type: 'smoothstep', animated: true,
            id: `ed-${i}-${i2}`, source: v.inverterId, target: modules[0].id
        });
        modules.some((v3, i3) => {
            
            if (modules.length > i3 + 1) {
                initialEdges.push({
                    type: 'smoothstep', animated: true,
                    id: `ed-${i}-${i2}-${i3}`,
                    source: v3.id,
                    target: modules[i3+1].id
                });
            }
            if (i3 > 0) x = x + (width+10)
            const position = {
                x: x,
                y: y
            }
            const moduleStyle = {
                background: '#F6F6F6',
                color: 'red',
                fontSize: 1,
                border: '1px solid #222138',
                width: width,
                height: height,
                //transform: `translate(${x}px, ${y}px) rotate(30deg)`
            }
            v3.position = position;
            v3.style = moduleStyle;
        })
    })
});
//console.log(initialEdges)


let id = 0;
const getId = () => `dndnode_${id++}`;

const HorizontalFlow = () => {
    const reactFlowWrapper = useRef(null);
    //const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
    //const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
    const [nodes, setNodes] = useState(initialNodes);
    const [edges, setEdges] = useState(initialEdges);
    const [reactFlowInstance, setReactFlowInstance] = useState(null);
    
    const onNodesChange = useCallback( (changes) => {
        return setNodes((ns) => {
            const index = ns.findIndex((e, index, array) => {
                return e.id === changes[0].id;
            });
            //ns[index].style.transform = `translate(${ns[index].position.x}px, ${ns[index].position.y}px) rotate(30deg)`
            return applyNodeChanges(changes, ns)
        }), []
    });

    const onEdgesChange = useCallback( (changes) => {
        return setEdges((es) => {
            return applyEdgeChanges(changes, es)
        }), []
    });

    //console.log(nodes, edges)
    const onConnect = useCallback((params) => {
        alert("connect");
        setEdges((eds) => {
            //console.log(params, eds);
            addEdge(params, eds)
        });
    }, []);
    const changeClassName = () => {
        setNodes((nds) =>
            nds.map((node) => {
                if (node.type === 'input') {
                    node.className = node.className ? '' : 'dark-node';
                }
                return { ...node };
            })
        );
    };

    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };
    const onDragOver = useCallback((event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
      }, []);
    
    const onDrop = useCallback((event) => {
        event.preventDefault();
    
        const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
        const type = event.dataTransfer.getData('application/reactflow');
    
        // check if the dropped element is valid
        if (typeof type === 'undefined' || !type) {
            return;
        }
    
        const position = reactFlowInstance.project({
            x: event.clientX - reactFlowBounds.left,
            y: event.clientY - reactFlowBounds.top,
        });
        //console.log(nodes)
        const newNode = {
            type,
            position,
            sourcePosition: "right",
            style: type === "input" ? inverterStyle : moduleStyle,
            data: { label: `새로운 ${type === "input" ? "인버터" : "모듈"}` },
        };
        if (type === "default") {
            newNode.id = getId();
            newNode.targetPosition = 'left';
        } else {
            const index = nodes.findIndex((e, index, array) => {
                return e.type === "input";
            });
            newNode.id = (parseInt(nodes[index].id) + 1).toString();
            newNode.data = { label: `인버터 ${newNode.id}`};
        }
        setNodes((nds) => nds.concat(newNode));
    },[reactFlowInstance]);

  return (
    
        <>
        <div>
            <div className="dndflow">
            <ReactFlowProvider>
                <div className="reactflow-wrapper" ref={reactFlowWrapper}>
                    <ReactFlow
                        nodes={nodes}
                        edges={edges}
                        onNodesChange={onNodesChange}
                        onEdgesChange={onEdgesChange}
                        onConnect={onConnect}
                        fitView
                        onInit={setReactFlowInstance}
                        onDrop={onDrop}
                        onDragOver={onDragOver}
                        snapToGrid={true}
                        //attributionPosition="bottom-left"
                    >
                        <button onClick={changeClassName} style={buttonStyle}>
                            change class name
                        </button>
                    </ReactFlow>
                </div>
                <aside>
                    <div className="description">You can drag these nodes to the pane on the right.</div>
                    <div className="dndnode input" onDragStart={(event) => onDragStart(event, 'input')} draggable>인버터</div>
                    <div className="dndnode" onDragStart={(event) => onDragStart(event, 'default')} draggable>모듈</div>
                    {/*
                    <div className="dndnode output" onDragStart={(event) => onDragStart(event, 'output')} draggable>
                        Output Node
                    </div>
                    */}
                </aside>
            </ReactFlowProvider>
            </div>
        </div>

        <style jsx>{`
            .reactflow-wrapper {
                margin-top: 150px;
            }
            .react-flow {
                position: fixed;
            }
            .dndflow {
                flex-direction: column;
                display: flex;
                flex-grow: 1;
                height: 100%;
              }
              
              .dndflow aside {
                border-right: 1px solid #eee;
                padding: 15px 10px;
                font-size: 12px;
                background: #fcfcfc;
              }
              
              .dndflow aside .description {
                margin-bottom: 10px;
              }
              
              .dndflow .dndnode {
                height: 20px;
                padding: 4px;
                border: 1px solid #1a192b;
                border-radius: 2px;
                margin-bottom: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: grab;
              }
              
              .dndflow .dndnode.input {
                border-color: #0041d0;
              }
              
              .dndflow .dndnode.output {
                border-color: #ff0072;
              }
              
              .dndflow .reactflow-wrapper {
                flex-grow: 1;
                height: 100%;
              }
              
              .dndflow .selectall {
                margin-top: 10px;
              }
              
              @media screen and (min-width: 768px) {
                .dndflow {
                  flex-direction: row;
                }
        `}</style>
    </>
  );
};

export default HorizontalFlow;
